import inventoryAPI from '@/services/api/inventory'
import Constant from '@/utils/defines/Constant'
import Cookies from '@/utils/modules/Cookies'

const index = {
	namespaced: true,
	state: () => ({
		type: undefined,
		count: undefined,
		searchInventoryList: [],
		recentKeyword: [],
		offset: 0,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		limit: 10,
		sortType: 1, // 1: 등록일순, 2: 이름순, 3: 위치 및 보관함,
		filter: {
			keyword: '',
			canUse: [false, false],
			registerMethods: [],
			categoriesId: [],
			storagesId: [],
			assigneesId: [],
			brandsId: [],
			expireDate: [],
			currentVolume: [],
			legalsId: [],
		},
	}),
	mutations: {
		initSearchInventoryList: (state, type) => {
			state.type = type
			state.count = 0
			state.searchInventoryList = []
			const searchList = Cookies.get(
				`${state.type}_${Constant.cookie.RECENT_SEARCH_LIST}`
			)
			state.recentKeyword =
				searchList !== null ? JSON.parse(searchList) : []
			state.offset = 0
			state.order = ['CREATE_DATETIME']
			state.orderDirection = ['DESC']
			state.length = 10
			state.sortType = 1 // 1: 등록일순, 2: 이름순, 3: 위치 및 보관함
			state.filter = {
				keyword: '',
				registerMethods: [],
				categoriesId: [],
				storagesId: [],
				assigneesId: [],
				brandsId: [],
				expireDate: [],
				currentVolume: [],
				legalsId: [],
			}
		},
		initSearchLegalInventoryList: (state, payload) => {
			state.searchInventoryList = undefined
			state.filter.legalsId = payload.legalsId
			state.type = payload.type
		},
		setKeyword: (state, payload) => {
			state.filter.keyword = payload
		},
		setOffset: (state, payload) => {
			state.offset = payload
		},
		setAssigneesId: (state, payload) => {
			state.filter.assigneesId = payload
		},
		setInventoryList: (state, payload) => {
			state.searchInventoryList = payload
		},
		setInventoryListCount: (state, payload) => {
			state.count = payload
		},
		setRecentKeywordList: (state, payload) => {
			state.recentKeyword = payload
			Cookies.set(
				`${state.type}_${Constant.cookie.RECENT_SEARCH_LIST}`,
				JSON.stringify(payload)
			)
		},
	},
	actions: {
		loadRecentKeywordList: async ({ commit, state }) => {
			let recentKeywordList = Cookies.get(
				`${state.type}_${Constant.cookie.RECENT_SEARCH_LIST}`
			)
			if (recentKeywordList === null || recentKeywordList === undefined) {
				recentKeywordList = []
				commit('setRecentKeywordList', recentKeywordList)
			} else {
				commit('setRecentKeywordList', JSON.parse(recentKeywordList))
			}
		},
		loadSearchInventoryList: async (
			{ commit, state, dispatch },
			payload
		) => {
			const { instId } = payload
			const params = {
				offset: state.offset,
				length: state.length,
				keyword: state.filter.keyword,
				assigneeId: state.filter.assigneesId,
				legalsId: state.filter.legalsId,
			}
			const response = await inventoryAPI.lookupInventoryListV2(
				instId,
				params
			)
			commit('setInventoryList', response.data.list)
			commit('setInventoryListCount', response.data.count)
			dispatch('loadRecentKeywordList')
		},
		addSearchInventoryList: async ({ commit, state }, payload) => {
			const { instId } = payload

			const params = {
				offset: state.offset,
				length: state.length,
				keyword: state.filter.keyword,
				assigneeId: state.filter.assigneesId,
				legalsId: state.filter.legalsId,
			}
			const response = await inventoryAPI.lookupInventoryListV2(
				instId,
				params
			)
			commit('setInventoryList', [
				...state.searchInventoryList,
				...response.data.list,
			])
		},
	},
}
export default index
